export function isTauriRuntime() {
  return typeof window !== 'undefined' && ('__TAURI_INTERNALS__' in window || '__TAURI__' in window)
}

function isEditableTarget(target) {
  if (!(target instanceof Element)) return false
  return Boolean(target.closest('input, textarea, [contenteditable="true"], .allow-text-select'))
}

/** Reduce browser-like interactions inside the desktop shell. */
export function initNativeAppBehavior() {
  if (!isTauriRuntime()) return () => {}

  document.documentElement.classList.add('tauri-app')

  const onContextMenu = (event) => {
    if (!isEditableTarget(event.target)) {
      event.preventDefault()
    }
  }

  const onDragStart = (event) => {
    if (!isEditableTarget(event.target)) {
      event.preventDefault()
    }
  }

  document.addEventListener('contextmenu', onContextMenu, true)
  document.addEventListener('dragstart', onDragStart, true)

  return () => {
    document.documentElement.classList.remove('tauri-app')
    document.removeEventListener('contextmenu', onContextMenu, true)
    document.removeEventListener('dragstart', onDragStart, true)
  }
}
